export const version = '5.0.0-beta.3';
